import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectorBlogState = (state: RootState) => state.blog;

export const selectorIsLoadingPosts = createSelector(
  selectorBlogState,
  (blogState) => blogState.isLoadingPosts
);

export const selectorPosts = createSelector(
  selectorBlogState,
  (blogState) => blogState.posts
);

export const selectorIsLoadingCategories = createSelector(
  selectorBlogState,
  (blogState) => blogState.isLoadingCategories
);

export const selectorCategories = createSelector(
  selectorBlogState,
  (blogState) => blogState.categories
);
